import { analyticsService } from '@meiuca/analytics';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SuggestArenaModal } from '../components/SuggestArenaModal'
import { useToast } from '../hooks/useToast'

export function SuggestArenaPage() {
  useEffect(() => {
    analyticsService.trackScreenView('suggest_arena');
  }, []);
  const navigate = useNavigate()
  const { showToast } = useToast()

  const handleClose = () => {
    navigate(-1) // Go back to previous page
  }

  const handleSuccess = (message: string) => {
    showToast({
      type: 'success',
      message,
      duration: 5000,
    })
    navigate(-1)
  }

  const handleError = (message: string) => {
    showToast({
      type: 'error',
      message,
      duration: 5000,
    })
  }

  return (
    <SuggestArenaModal
      open={true}
      onClose={handleClose}
      onSuccess={handleSuccess}
      onError={handleError}
    />
  )
}
